import { PAYMENT_METHODS } from './index';


export const OPTIONALLY_AVAILABLE_PAYMENT_METHODS = [
	PAYMENT_METHODS.directDebit,
	PAYMENT_METHODS.suPayout,
	PAYMENT_METHODS.suPaymentMethods,
	PAYMENT_METHODS.suBusinessAccount,
];

export const TOKENIZATION_PAYMENT_METHODS = [
	PAYMENT_METHODS.creditCard,
	PAYMENT_METHODS.directDebit,
	PAYMENT_METHODS.businessAccount,
];

export const isPaymentMethodAvailable = (availablePaymentMethods = {}, paymentMethodType) => {
	if (!OPTIONALLY_AVAILABLE_PAYMENT_METHODS.includes(paymentMethodType)) {
		return true;
	}
	return Boolean(availablePaymentMethods[paymentMethodType]);
};
